module.exports = __webpack_public_path__ + "static/ci-ed46bb70a48ce7c58755ad2caeda83a0.jpg";